import { render, staticRenderFns } from "./investWork.vue?vue&type=template&id=628f862b&"
import script from "./investWork.vue?vue&type=script&lang=js&"
export * from "./investWork.vue?vue&type=script&lang=js&"
import style0 from "./investWork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports